/**
 *
 * @param {number} BREAK_POINT window width | 1024 is default
 * @returns bool
 * true if window width is less than BREAK_POINY
 */
export const checkScreenBreakPoint = (BREAK_POINT = 1024) => window.innerWidth < BREAK_POINT;
